<!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
<!-- Router -->
<router-outlet *ngIf="!isIframe"></router-outlet>
<!-- Router -->

<!-- Toast -->
<p-toast></p-toast>
<!-- Toast -->
